import { apiDelete, apiGet, apiPost, apiPut } from './api';

export type PlaybackRow = {
  _id: string;
  id?: string;
  title?: string;
  code?: string;
  description?: string;
  status?: string;
  isPublic?: boolean;
  documentId?: string;
  author?: { email?: string; nickname?: string };
  tags?: string[];
  playbackParts?: Array<{
    partName?: string;
    audioTempos?: Array<{ audioFile?: string; tempo?: number }>;
  }>;
  lastModified?: string;
  createdAt?: string;
};

export async function listPlaybacks(params: Record<string, string | number> = {}) {
  const qs = new URLSearchParams(
    Object.entries(params).map(([k, v]) => [k, String(v)])
  ).toString();
  return apiGet<{ success: boolean; data?: { playbacks: PlaybackRow[] }; message?: string }>(
    `/api/v1/playbacks${qs ? `?${qs}` : ''}`
  );
}

export async function getPlayback(id: string) {
  return apiGet<{ success: boolean; data?: { playback: PlaybackRow } }>(`/api/v1/playbacks/${id}`);
}

export async function createPlayback(body: Record<string, unknown>) {
  return apiPost('/api/v1/playbacks', body);
}

export async function updatePlayback(id: string, body: Record<string, unknown>) {
  return apiPut(`/api/v1/playbacks/${id}`, body);
}

export async function deletePlayback(id: string) {
  return apiDelete(`/api/v1/playbacks/${id}`);
}
